import { FC } from 'react';

import { Modal } from '../../../../components/modal/index';
import { popupStore } from './popup.store';

export const DeactivatePerkPopup: FC = () => {
  const isOpen = popupStore(({ open }) => open);

  const handleAccept = popupStore(({ handleAccept }) => handleAccept);
  const handleDismiss = popupStore(({ handleDismiss }) => handleDismiss);

  return (
    <Modal
      description="Are you sure you want to deactivate this perk? The perk will be removed from the landing page and the app. You can activate this perk again later."
      dismissButtonContent="Cancel"
      isOpen={isOpen}
      onDismiss={handleDismiss}
      onSuccess={handleAccept}
      successButtonClassName="bg-brand-700"
      successButtonContent="Deactivate"
      title="Deactivate Perk"
    />
  );
};
